import React, { useEffect, useState } from "react";
import "./auth.css";
import loginImage from "../../Assets/Group.svg";
import Alert from "@mui/material/Alert";
import roccologo from "../../Assets/Roccologo.png";
import { login } from "../../DAL/auth";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const Login = ({ onLoginSuccess }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [isHiding, setIsHiding] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");
    setAlertType("");

    const { email, password } = formData;

    if (!email || !password) {
      setMessage("Email and Password are required.");
      setAlertType("error");
      return;
    }

    setLoading(true);
    try {
      const payload = { username: email, password };
      const response = await login(payload);

      if (response.status === 201) {
        setMessage("Login Successful!");
        setAlertType("success");
        localStorage.setItem(
          "rocco_live-access-Token-for-web",
          response?.data.accessToken
        );
        localStorage.setItem("user", JSON.stringify(response?.data.user));
        onLoginSuccess();
      } else {
        setMessage(response.message);
        setAlertType("error");
      }
    } catch (error) {
      setMessage(
        error.response?.data?.message || "An error occurred during login."
      );
      setAlertType("error");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (message) {
      setShowAlert(true);
      setIsHiding(false);

      const timer = setTimeout(() => {
        setIsHiding(true);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [message]);

  useEffect(() => {
    if (isHiding) {
      const hideTimer = setTimeout(() => {
        setShowAlert(false);
        setIsHiding(false);
      }, 500);

      return () => clearTimeout(hideTimer);
    }
  }, [isHiding]);

  return (
    <div className="Login-page">
      <div className="login-left-area">
        <div className="logo-area">
          <img src={roccologo} alt="Logo" className="logo" />
          <p className="logo-heading">Welcome to RB Live</p>
          <form onSubmit={handleLogin} style={{ width: "100%" }}>
            <div className="form-group">
              <label htmlFor="email">Work email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div style={{ position: "relative" }}>
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  style={{ paddingRight: "40px" }}
                />
                <span
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </span>
              </div>
            </div>

            {showAlert && message && (
              <div className={`Alert-message-area ${isHiding ? "hidden" : ""}`}>
                <Alert severity={alertType} sx={{ marginTop: "20px" }}>
                  {message}
                </Alert>
              </div>
            )}
            <button className="gradient-button" disabled={loading}>
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
      <div className="login-right-area">
        <img src={loginImage} alt="Login" />
      </div>
    </div>
  );
};

export default Login;
